import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/app/providers/AuthProvider';
import { buildLocationReturnUrl, buildLoginUrl } from '@/lib/navigation';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full w-full min-h-[200px]">
        <svg className="w-8 h-8 animate-spin text-theme-color" viewBox="0 0 24 24" fill="none">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2.5"
          />
          <path
            className="opacity-90"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnUrl = buildLocationReturnUrl(location);

    return <Navigate to={buildLoginUrl(returnUrl)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
